import React, { useState, useEffect } from 'react';
import './Navbar.css';
import * as icons from '../icons/Icons';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMobileMenuOpen] = useState(false);

  const paths = [
    { id: '/', label: 'Home' },
    { id: 'about', label: 'About me' },
    { id: 'contact', label: 'Contact' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (id) => {
    const path = id === '/' ? '/' : `/${id}`;
    return location.pathname === path;
  };

  const handleNav = (id) => {
    navigate(`/${id}`);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <div className="container navbar-content">

          <button className="logo-btn" onClick={() => navigate('/')}>
            <img src={icons.logo} alt="logo" width="100px" />
          </button>

          <ul className="nav-links">
            {paths.map((p) => (
              <li key={p.id}>
                <button
                  className={`nav-link ${isActive(p.id) ? 'nav-link--active' : ''}`}
                  onClick={() => handleNav(p.id)}
                >
                  {p.label}
                  <span className="nav-link-underline" />
                </button>
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <button
              className="music-nav-btn"
              onClick={() => navigate('/music')}
              aria-label="Music"
            >
              ♪
            </button>
            <button className="btn-nav-contact" onClick={() => navigate('/contact')}>
              Contact me
            </button>

            <button
              className={`hamburger ${menuOpen ? 'hamburger--open' : ''}`}
              onClick={() => setMobileMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>

        </div>
      </nav>

      <div className={`mobile-menu ${menuOpen ? 'mobile-menu--open' : ''}`}>
        <ul className="mobile-links">
          {paths.map((p, i) => (
            <li key={p.id} style={{ '--i': i }}>
              <button
                className={`mobile-link ${isActive(p.id) ? 'mobile-link--active' : ''}`}
                onClick={() => handleNav(p.id)}
              >
                {p.label}
              </button>
            </li>
          ))}
        </ul>
        <button className="btn-nav-contact mobile-cta" onClick={() => navigate('/contact')}>
          Contact me
        </button>
      </div>

      {menuOpen && (
        <div className="menu-overlay" onClick={() => setMobileMenuOpen(false)} />
      )}
    </>
  );
}